import React from 'react';
import {
  Box,
  VStack,
  Text,
  Button,
  Input,
} from '@chakra-ui/react';
import {
  ArrowForwardIcon,
} from '@chakra-ui/icons';
import { useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { calculateSize } from '../helpers';

interface QuillEditorProps {
    onSubmit: (title: string, value: string) => void,
    topText: string
    topTextSize: string
    hasTitleField: boolean
    p: string
    m: string
    titleContents?: string
    contents?: string
    width: number
  }

const QuillEditor = ({onSubmit, topText, topTextSize, hasTitleField, p, m, titleContents, contents, width}: QuillEditorProps) => {
    const [titleValue, setTitleValue] = useState(titleContents ? titleContents : '');
    const [value, setValue] = useState(contents ? contents : '');
    let size = calculateSize(48, width)
    if (topTextSize === "medium") {
      size = calculateSize(24, width)
    } else if (topTextSize === "small") {
      size = calculateSize(18, width)
    } 

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setTitleValue(event.target.value);
      }

    return (
        <Box width='100%' pl={p} pr={p} marginBottom={m} backgroundColor={'whitesmoke'}>
            <Text fontSize={size} style={{fontWeight: 'bold'}} pl={p} pr={p}>
                {topText}
            </Text>
            <VStack width='100%' pl={p} pr={p} marginBottom={m}>
                {hasTitleField && <Input placeholder='Title...' rounded='false' value={titleValue} onChange={handleChange}/>}
                <Box width='100%'>
                    <ReactQuill theme="snow" value={value} onChange={setValue}/>
                </Box>
                <Button
                    rightIcon={<ArrowForwardIcon />}
                    variant='solid'
                    color='white'
                    backgroundColor='green'
                    size='lg'
                    onClick={() => onSubmit(titleValue, value)}
                >
                    Submit
                </Button>
            </VStack>
        </Box>
    );
};

export default QuillEditor